import { Injectable } from '@angular/core';
import { ActivatedRouteSnapshot, CanActivate, Router, RouterStateSnapshot } from '@angular/router';
import { Observable } from 'rxjs';
import { map, catchError } from 'rxjs/operators';
import { ContextsService } from 'src/app/api';
import { CreateContextRequestBuilder } from '../components/redirect/builders/create-context-request.builder';
import { ERROR_PATH, SUBSCRIPTION_PATH } from '../constants/route.constants';
import { environment } from 'src/environments/environment';

@Injectable({
  providedIn: 'root'
})
export class ProductGuard implements CanActivate {
  constructor(
    private router: Router,
    private contextService: ContextsService
  ) {}

  canActivate(
    route: ActivatedRouteSnapshot,
    state: RouterStateSnapshot
  ): Observable<boolean> | Promise<boolean> | boolean {
    const productCode = route.paramMap.get('productCode');

    if (!productCode) {
      console.error('Le productCode est null ou vide.');
      return false;
    }

    const requestBody = new CreateContextRequestBuilder()
      .withProduit(productCode)
      .withCodeVendeur(environment.brand)
      .build();

    let authorize = JSON.parse(environment.authorizeProspectBrands) as string[];

    if (authorize.some(m => m == environment.brand))
      return this.contextService.apiContextsPost(requestBody).pipe(
        map((result: string) => {
          const url = new URL(result);
          this.router.navigate([url.pathname.replace('/' + SUBSCRIPTION_PATH, '')]);
          return false;
        }),
        catchError(err => {
          console.error('Erreur lors de la création du context :', err);
          return [false];
        })
      );
    else {
      this.router.navigate([ERROR_PATH]);
      return false;
    }
  }
}
